import React from 'react'

import { WalletConnectControl, type WalletConnectControlProps } from './WalletConnectControl'

/** Conector en barra superior (desktop). */
export function WalletConnectButton(props: Omit<WalletConnectControlProps, 'variant'>) {
  return <WalletConnectControl variant="header" {...props} />
}
